export default {"src":"/_next/static/media/telephone-icon.5c57d077.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};